/* ==========================================================
   Kefit Store — Related Products carousel (v2)
   Native overflow scrolling + drag, wheel, keyboard, arrows.
   No dependencies. Safe to load with `defer`.
   ========================================================== */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 6; // px before a drag suppresses the click

  function init(root) {
    if (!root || root.dataset.kefitReady === 'true') return;
    root.dataset.kefitReady = 'true';

    var track = root.querySelector('[data-kefit-track]');
    if (!track) return;

    var prev = root.querySelector('[data-kefit-prev]');
    var next = root.querySelector('[data-kefit-next]');

    /* ---------- helpers ---------- */
    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function overflows() {
      return maxScroll() > 2;
    }

    function step() {
      var card = track.querySelector('.kefit-card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var cardWidth = card.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / cardWidth));
      return cardWidth * perView;
    }

    function scrollByCards(dir) {
      track.scrollBy({ left: dir * step(), behavior: prefersReduced() ? 'auto' : 'smooth' });
    }

    function prefersReduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function sync() {
      var scrollable = overflows();
      track.classList.toggle('is-static', !scrollable);
      track.classList.toggle('is-draggable', scrollable);
      track.setAttribute('tabindex', scrollable ? '0' : '-1');

      if (prev) {
        prev.disabled = !scrollable || track.scrollLeft <= 2;
      }
      if (next) {
        next.disabled = !scrollable || track.scrollLeft >= maxScroll() - 2;
      }
    }

    /* ---------- arrows ---------- */
    if (prev) prev.addEventListener('click', function () { scrollByCards(-1); });
    if (next) next.addEventListener('click', function () { scrollByCards(1); });

    /* ---------- keyboard ---------- */
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', window.kefitT('related_carousel', 'Related products carousel'));
    track.addEventListener('keydown', function (e) {
      if (!overflows()) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByCards(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByCards(-1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: maxScroll(), behavior: 'smooth' }); }
    });

    /* ---------- mouse wheel → horizontal ---------- */
/* ---------- mouse wheel ---------- */
/* Keep native vertical page scrolling. Do not hijack the mouse wheel. */

    /* ---------- pointer drag-to-scroll ---------- */
    var dragging = false, moved = false, startX = 0, startScroll = 0, pointerId = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;       // native touch scrolling
      if (e.button !== 0 || !overflows()) return;
      dragging = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pointerId); } catch (err) {}
      }
      if (moved) {
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      }
    });

    function endDrag(e) {
      if (!dragging || (e && pointerId !== null && e.pointerId !== pointerId)) return;
      dragging = false;
      try { if (pointerId !== null) track.releasePointerCapture(pointerId); } catch (err) {}
      pointerId = null;
      if (moved) {
        track.classList.remove('is-dragging');
        // swallow the click that follows a real drag
        window.setTimeout(function () { moved = false; }, 0);
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ---------- state sync ---------- */
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(function () { sync(); }).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }
    window.addEventListener('load', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-kefit-related]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor / section re-render support
  document.addEventListener('shopify:section:load', boot);
})();
